export default "icons/send.svg"